import base from '../dr-base'
import drStepper from './dr-stepper.vue'

const schema = {
  ...base,
  $Type: 'dr-stepper',
  name: 'Stepper',
  group: 'Advanced',
  icon: 'step-forward',
  properties: {
    ...base.properties,
    Stages: {
      name: 'vuetifyWidgets.dr-stepper.name',
      type: 'string',
      HintText: 'vuetifyWidgets.dr-stepper.format'
    }
    // Описание структоры Stepper
  //   Stages: [
  //     {
  //       number:{
  //         type: 'integer',
  //       },
  //       icon: {
  //         type: 'string',
  //       },
  //       text: {
  //         type: 'string',
  //       },
  //       color: {
  //         type: 'string',
  //       }
  //     }
  //   ]
  }
}

export default {
  schema,
  component: drStepper
}
  